import { EditIcon } from '@clubspark-react/ui';
import { useTranslation } from 'react-i18next';

import useStyles from './style';

type Props = {
  value: string;
  index: number;
  label: string;
  onClick: (e: any) => void;
};
const InputWithUnderline = ({ value, label, onClick }: Props) => {
  const { classes, cx } = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classes.container} role="button" tabIndex={0} onClick={onClick} onKeyDown={onClick}>
      <div className={classes.label}>{label}</div>
      <div className={classes.content}>
        <span className={cx(classes.underlinedInputValue, 'inputValue')}>{value}</span>
        <div className={'editContainer'} id="edit">
          <div>
            <EditIcon />
          </div>
          <span>{t('Edit')}</span>
        </div>
      </div>

      <div className="underline" />
    </div>
  );
};

export default InputWithUnderline;
